import { Box, Stack, Typography } from "@mui/material";
import { DebugBox, LoadingBox, useNavigateWithParams } from "@northpowerdev/np-react-utils";
import EmojiNatureIcon from '@mui/icons-material/EmojiNature';

import { useState } from "react";
import { useEffect } from "react";

import { StyledDataGrid } from "./DlspStyledDataGrid";
import { hikoAlert } from "../../../utils/HikoAlert";
import { plural, safeFormatDate } from "../../../utils/utilityFunctions";
import DlspTaskStatusChip from "../../styled/DlspTaskStatusChip";
import useFetchJson from "../../../data/useFetchJson";


const isoDateStringFormatter = (formatterParams) => safeFormatDate(formatterParams.value, 'd MMM h:mmaaa')
const renderPriorityQA = (params) => params.row.priorityFieldQA === 'Yes' ?<Typography align="center" sx={{width:'100%'}} ><EmojiNatureIcon fontSize="medium" /></Typography> : '' 

const gridColumns = [
    { field: 'fieldInspDate',     headerName: 'Field Inspect Date',     flex: 1, valueFormatter: isoDateStringFormatter },
    { field: 'fieldInspBy',       headerName: 'Field Inspect By',       flex: 1 },
    { field: 'priorityFieldQA',   headerName: 'Priority QA',    flex: 0, renderCell: renderPriorityQA },
    { field: 'icp',               headerName: 'ICP',            flex: 1, minWidth: 150 }, 
    { field: 'stormArea',         headerName: 'Storm Area',     flex: 1 },
    { field: 'dsubSuburb',        headerName: 'Suburb',         flex: 1 },
    { field: 'fieldInspCommentsSummary', headerName: 'Field Comments', flex: 1 },
    { field: 'desktopQAOwner',    headerName: 'QA Owner',       flex: 1 },
];

export default function DlspFieldQATaskList() {

    const [orderedTaskList, setOrderedTaskList] = useState([])

    const getTaskListPath = '/bff/decommissioned-lines-service/api/decommissioned-lines/list-field-qa-tasks'
    const fieldQATasksParams = {
        pageIdx: 0,
        pageSize: 1000,
    }
    const {
        isLoading: taskListLoading,
        data: taskList, 
    } = useFetchJson(getTaskListPath, {params: fieldQATasksParams}, true)

    const navigateToTaskDetails = useNavigateWithParams('/dlsp/task/details')

    useEffect(() => {
        if (!taskList) return

        setOrderedTaskList([...taskList].map((listTask) => {
            return {
                priorityFieldQA: listTask.fieldChecklist?.fieldInspectionPriority,
                icp: listTask.icp,
                stormArea: listTask.stormArea,
                dsubSuburb: listTask.dsubSuburb,
                fieldInspBy: listTask.fieldInspBy,
                fieldInspDate: listTask.fieldInspDate,
                fieldInspCommentsSummary: listTask.fieldChecklist?.fieldInspectionComments.length > 100 ? `${ listTask.fieldChecklist?.fieldInspectionComments.slice(0, 150)}...` :  listTask.fieldChecklist?.fieldInspectionComments,
                desktopQAOwner: listTask.desktopQAOwner
            }

            }).sort((a, b) => {
                return (b.fieldInspDate || '').localeCompare(a.fieldInspDate || '')
            })
        )
    }, [taskList])

    const handleRowClick = (params, event, details) => {
        console.log('handleRowClick', { params, event, details })
        if (!params.row.icp) {
            hikoAlert('No icp in that row!')
            return
        }
        let navigateParams = { icp_number: params.row.icp }
        navigateToTaskDetails(navigateParams)
    }

    return (
        <Box className="Page">
            <h3>Decommissioned Lines Safety Project</h3>
            <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'left' }}>
                <h2>Field QA Tasks</h2>
                <DlspTaskStatusChip sx={{ pl: 2 }} status="Field QA" />
            </Stack>

            <LoadingBox loading={taskListLoading}>

                <Typography variant="body1">We found {orderedTaskList?.length || 'no'} task{plural(orderedTaskList?.length)}.</Typography>

                <StyledDataGrid sx={{ my: 2 }} autoHeight rows={orderedTaskList || []}
                    getRowId={(row) => row.icp}
                    columns={gridColumns}
                    onRowClick={handleRowClick}
                    getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'}
                />
                <DebugBox title="taskList" stringify>{taskList}</DebugBox>
            </LoadingBox>


        </Box>
    )
}